module.exports = __webpack_public_path__ + "static/media/JSTOR.1aa8088a.png";